export default __webpack_public_path__ + "static/media/vc.a7f01b60.jpeg";